module.exports = __webpack_public_path__ + "img/03-2-1人工成本.a6fb9931.svg";